(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.k12DataManagement.name)
        .controller('addClusterConfigCtrl', [
            '$rootScope', '$scope', '$timeout', '$http', '$uibModal', '$location', '$q', '$anchorScroll', '$state',
            schoolwork12.app.auth.services.authentication,
            schoolwork12.app.common.services.eventNotification,
            schoolwork12.app.k12DataManagement.services.k12DataManagementSvc,
            function ($rootScope, $scope, $timeout, $http, $uibModal, $location, $q, $anchorScroll, $state,
                authentication, eventNotification, k12DataManagementSvc) {

                console.info("In add school plan controller");
                $scope.forms = {};
                $rootScope.hideK12DataMngmt = true;
                $scope.clusterConfigSaveError = false;
                $scope.isK12DataSaveBusy = false;

                //intercept any routing in case the user tries to navigate outside with unsaved changes.
                $scope.$parent.$on('$stateChangeStart', function (event, next, current) {
                    if ($scope.forms.clusterConfig.$dirty) {
                        event.preventDefault();
                        clusterConfigUnsavedChanges().result.then(function (leave) {
                            if (leave) {
                                $scope.forms.clusterConfig.$setPristine();
                                $location.url(next.url);
                            } else {
                                //in case the user wants to remain in ClusterConfi Form and he had tried to navigate away
                                //to another component, we hide the parent again since It will be re shown because of the 
                                //auth-route-listener.getStateRouteConfigurations().
                                $rootScope.hideK12DataMngmt = true;
                            }
                        });
                    }
                });

                //Initializing the object comming from the Parent.
                if ($state.params.clusterConfigObject != null) {
                    $scope.clusterConfig = $state.params.clusterConfigObject;
                    $scope.operationType = $state.params.operation;
                }

                //Error Messages Variables
                $scope.clusterConfigNameRequired = schoolwork12.app.k12DataManagement.errorMessages.clusterConfigNameRequired;
                $scope.clusterConfigDescRequired = schoolwork12.app.k12DataManagement.errorMessages.clusterConfigDescRequired;
                $scope.clusterConfigItemKeyRequired = schoolwork12.app.k12DataManagement.errorMessages.clusterConfigItemKeyRequired;
                $scope.clusterConfigItemValueRequired = schoolwork12.app.k12DataManagement.errorMessages.clusterConfigItemValueRequired;
                $scope.clusterConfigItemRequired = schoolwork12.app.k12DataManagement.errorMessages.clusterConfigItemRequired;

                $scope.addConfigItem = function (configItem, index) {
                    let clusterConfigScope = $scope;
                    let addConfigItemModalInstance = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'clusterConfigItemModal.html',
                        windowClass: 'alert-Modal',
                        keyboard: false,
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
                                //current Modal Scope
                                let configItemModalScope = $scope;

                                //Initializing Error Messages
                                $scope.clusterConfigItemKeyRequired = clusterConfigScope.clusterConfigItemKeyRequired;
                                $scope.clusterConfigItemValueRequired = clusterConfigScope.clusterConfigItemValueRequired;

                                //Validate if user attempt to create or edit an existing configuration item
                                if (configItem != null) {
                                    configItemModalScope.configItemDetails = angular.copy(configItem);
                                } else {
                                    configItemModalScope.configItemDetails = {
                                        id: -1,
                                        configKey: "",
                                        configValue: "",
                                        status: 1,
                                        isEdited: true
                                    }
                                }

                                let resetFormErrorMessages = function () {
                                    configItemModalScope.forms.clusterConfigItem['configItemKey'].$setValidity('keyRequired', true);
                                    configItemModalScope.forms.clusterConfigItem['configItemValue'].$setValidity('valueRequired', true);
                                };

                                configItemModalScope.addConfigItemModal = function () {
                                    resetFormErrorMessages();
                                    if (validateConfigItemForm()) {
                                        //STT-9782:Cluster configuration values can not be modified
                                        $scope.configItemDetails.isEdited = true;
                                        $uibModalInstance.close({
                                            configItemDetails: $scope.configItemDetails,
                                            index: index
                                        });
                                    }
                                };
                                //$scope.deleteSchoolClusterMsg= "You are about to delete an existing School Cluster. Do you want to continue?";
                                configItemModalScope.cancelConfigItemModal = function () {
                                    if (configItemModalScope.forms.clusterConfigItem.$dirty) {
                                        configItemModalScope.unSavedChangesAlert().result.then(function (leave) {
                                            if (leave) {
                                                $uibModalInstance.close(false);
                                            }
                                        })
                                    } else {
                                        $uibModalInstance.close(false);
                                    }
                                };

                                let validateConfigItemForm = function () {
                                    let result = true;

                                    //validate if key is null or empty
                                    if (configItemModalScope.configItemDetails.configKey == null || (configItemModalScope.configItemDetails.configKey).trim() == '') {
                                        configItemModalScope.forms.clusterConfigItem['configItemKey'].$setValidity('keyRequired', false);
                                        result = false;
                                    }

                                    //validate if key is null or empty
                                    if (configItemModalScope.configItemDetails.configValue == null || (configItemModalScope.configItemDetails.configValue).trim() == '') {
                                        configItemModalScope.forms.clusterConfigItem['configItemValue'].$setValidity('valueRequired', false);
                                        result = false;
                                    }
                                    return result;
                                }

                                configItemModalScope.unSavedChangesAlert = function () {
                                    let unSavedChangesModalInstance = $uibModal.open({
                                        animation: $scope.animationsEnabled,
                                        templateUrl: 'clusterConfigItemUnsavedChanges.html',
                                        windowClass: 'alert-Modal',
                                        keyboard: false,
                                        backdrop: 'static',
                                        controller: ['$scope', '$uibModalInstance',
                                            function ($scope, $uibModalInstance2) {
                                                //current Modal Scope
                                                let configItemUnsavedModalScope = $scope;
                                                configItemUnsavedModalScope.discardClusterConfigItemChanges = function () {
                                                    $uibModalInstance2.close(true);
                                                };

                                                configItemUnsavedModalScope.clusterConfigItemUnsavedChangesMsg = "You have unsaved changes. Do you want to continue without saving the changes?";

                                                configItemUnsavedModalScope.remainClusterConfigItemChanges = function () {
                                                    $uibModalInstance2.close(false);
                                                };

                                            }
                                        ],
                                    });

                                    return unSavedChangesModalInstance;
                                }
                            }
                        ],
                    });
                    addConfigItemModalInstance.result.then(function (option) {
                        if (typeof (option) === 'object') {
                            if (option.index != null) {
                                $scope.clusterConfig.clusterConfigItems[index] = option.configItemDetails;
                            } else {
                                //avoid to add configItem if user tries to duplicated an existing configItem
                                let duplication = _.find($scope.clusterConfig.clusterConfigItems, element => element.configKey === option.configItemDetails.configKey)
                                if (duplication == null) {
                                    $scope.clusterConfig.clusterConfigItems.push(option.configItemDetails);
                                }

                            }
                            $scope.forms.clusterConfig.$setDirty();
                            $scope.clusterConfigModified();
                        }
                    });
                };

                let resetClusterConfigFormErrors = function (){
                    $scope.forms.clusterConfig['configName'].$setValidity('clusterConfiNameRequired', true);
                    $scope.forms.clusterConfig['configDescription'].$setValidity('clusterConfigDescRequired', true);
                    $scope.clusterConfigItemsRequired = false;
                }

                let validateClusterConfigForm = function () {
                    let result = true;
                    resetClusterConfigFormErrors();
                    //Validate if name is null or empty
                    if ($scope.clusterConfig.name == null || ($scope.clusterConfig.name).trim() == '') {
                        $scope.forms.clusterConfig['configName'].$setValidity('clusterConfiNameRequired', false);
                        result = false;
                    }
                    //Validate if Description is null or empty
                    if ($scope.clusterConfig.description == null || ($scope.clusterConfig.description).trim() == '') {
                        $scope.forms.clusterConfig['configDescription'].$setValidity('clusterConfigDescRequired', false);
                        result = false;
                    }

                    if($scope.clusterConfig.clusterConfigItems.length == 0 || 
                        $scope.clusterConfig.clusterConfigItems.length == $scope.clusterConfig.clusterConfigItems.filter(x => x.status == 0).length){
                            $scope.clusterConfigItemsRequired = true;
                            result = false;
                    }
                    return result;
                }

                $scope.deleteConfigItem = function (index, clusterConfigItem) {
                    let deleteConfigItemModal = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'clusterConfigItemDeletion.html',
                        windowClass: 'alert-Modal',
                        keyboard: false,
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance2) {
                                //current Modal Scope
                                let configItemDeletionModalScope = $scope;
                                configItemDeletionModalScope.okDeleteClusterConfigItem = function () {
                                    $uibModalInstance2.close(true);
                                };

                                configItemDeletionModalScope.clusterConfigItemDeletionMsg = "You are about to delete the Key '" + clusterConfigItem.configKey + "' Do you want to continue?";

                                configItemDeletionModalScope.cancelDeleteClusterConfigItem = function () {
                                    $uibModalInstance2.close(false);
                                };

                            }
                        ],
                    });

                    deleteConfigItemModal.result.then(function (deletion) {
                        if (deletion) {
                            if (clusterConfigItem.id != -1) {
                                clusterConfigItem.status = 0;
                                clusterConfigItem.isEdited = true;
                            } else {
                                $scope.clusterConfig.clusterConfigItems.splice(index, 1);
                            }
                            $scope.forms.clusterConfig.$setDirty();
                            $scope.clusterConfigModified();
                        }
                    })
                }

                $scope.clusterConfigModified = function () {
                    $scope.clusterConfig.isEdited = true;
                }

                $scope.saveClusterConfig = function () {
                    if (validateClusterConfigForm()) {
                        $scope.isK12DataSaveBusy = true;
                        let k12DataManagementSvcPromise = k12DataManagementSvc.saveClusterConfig(authentication.getCurrentUser().keycode, $scope.clusterConfig);
                        k12DataManagementSvcPromise.then(function (data) {
                            if (data) {
                                console.info("Cluster Config Saved");
                                $scope.forms.clusterConfig.$setPristine();
                                //notify parent about the success saved
                                $scope.$emit("clusterConfigSaved", true);
                                $state.go("k12DataManagement");
                            }
                        }, function (error) {
                            console.info('Error retrieving Cluster Config list....'.concat(angular.toJson(error)));
                            $scope.clusterConfigSaveError = true;
                            $scope.clusterConfigSaveErrorMsg = '';
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.clusterConfigSaveErrorMsg = $scope.k12DataErrorOccurredMsg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.clusterConfigSaveErrorMsg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.clusterConfigSaveErrorMsg = schoolwork12.app.errorMessages.internalError;
                            }

                        })['finally'](function () {
                            $scope.isK12DataSaveBusy = false;
                        });
                    }
                }

                let clusterConfigUnsavedChanges = function () {
                    let operation = $scope.operationType == 'Edit' ? 'Editing' : 'Creating';
                    let clusterConfigUnsavedChangesModal = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'clusterConfigUnsavedChanges.html',
                        windowClass: 'alert-Modal',
                        keyboard: false,
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
                                $scope.discardClusterConfigChanges = function () {
                                    $uibModalInstance.close(true);
                                };
                                $scope.clusterConfigUnsavedChangesMsg = "You have began " + operation + " a Cluster Configuration and this have unsaved changes. Do you want to continue without saving the changes?";
                                $scope.remainClusterConfigChanges = function () {
                                    $uibModalInstance.close(false);
                                };
                            }
                        ],
                    });
                    return clusterConfigUnsavedChangesModal;
                }

                $scope.canceClusterConfigForm = function () {

                }


            }]);


}(angular, schoolwork12));